export const SELECT_IMAGE_OPEN_SOURCES = Object.freeze({
  FIELDS_REPLACE_IMAGE: 'fields-replace-image',
  FIELDS_REPLACE_IMAGES: 'fields-replace-images',
  FIELDS_ADD_IMAGES: 'fields-add-images',
});
